;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { safeStructuredClone } from './safe-structured-clone'

/**
 * Clones an error and returns a new error with the same properties.
 *
 * Useful for logging redacted errors
 */
export function cloneError<TError extends Error>(error: TError) {
  const clonedError = Object.create(Object.getPrototypeOf(error)) as TError
  // Copy enumerable own properties (e.g., custom fields like `details`)
  for (const [key, value] of Object.entries(error)) {
    clonedError[key as keyof TError] = safeStructuredClone(value)
  }

  // Copy standard non-enumerable Error fields as own properties so errors
  // with getter-only fields (e.g. ZodError.message) can still be cloned.
  Object.defineProperty(clonedError, 'name', {
    value: error.name,
    writable: true,
    enumerable: false,
    configurable: true,
  })
  Object.defineProperty(clonedError, 'message', {
    value: error.message,
    writable: true,
    enumerable: false,
    configurable: true,
  })
  Object.defineProperty(clonedError, 'stack', {
    value: error.stack,
    writable: true,
    enumerable: false,
    configurable: true,
  })

  return clonedError
}
